const humidityRecipe = {
  type: "humidity",
  recordForm: {
    // sonde capacitive
    measurementHour: null,
    humidity: null,
    temperature: null,
    staticPressure: null,
    sondeCapacitive: null,
    // gravimetrie
    balance: null,
    masseEtalon: null,
    // gravimetrie sur paramètre
    sample: null,
    // gravimetrie sur humidité
    isMeasurementStarted: false,
    isMeasurementEnded: false,
    measurements: [],
    compteur: null,
    // global
    effluentTemperature: 0,
    volumetricContent: null,
    measuredVolumetricContent: null,
    isEffluentWaterSaturated: null,
    isValidated: false,
  },
  recordBlocks: [],
  premix: [
    // sonde capacitive
    "recordForm.measurementHour",
    "recordForm.humidity",
    "recordForm.temperature",
    "recordForm.staticPressure",
    "recordForm.sondeCapacitive",
    // gravimetrie
    "recordForm.balance",
    "recordForm.masseEtalon",
    // gravimetrie sur humidité
    "recordForm.isMeasurementStarted",
    "recordForm.isMeasurementEnded",
    "recordForm.compteur",
    // global
    "recordForm.volumetricContent",
    "recordForm.measuredVolumetricContent",
    "recordForm.isEffluentWaterSaturated",
    "recordForm.isValidated",
  ],
};

const humidityRecipeMessages = {
  fr: {
    "humidity.humidity_measurement_form": "Humidité",
    "humidity.block.humidity_measurement_form": "Relevé",
  },
  en: {
    "humidity.humidity_measurement_form": "Humidity",
    "humidity.block.humidity_measurement_form": "Measurment",
  },
};

export { humidityRecipe, humidityRecipeMessages };
